import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import FairHousing from '../FairHousing';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import ExpandMySearch from '../ExpandMySearch';
import { expandSearch, lastViewed } from 'app/shared/flux/actions/HomeHubActions';
import { homeHubAsideCSS } from 'app/shared/modules/HomeHub/styles';
import type { RootReduxState } from 'app/shared/flux/reducers';

function Aside() {
  const dispatch = useDispatch();
  const recentArea = useSelector((state: RootReduxState) => state.user.search.recent.areaInfo);
  const userLocation = useSelector((state: RootReduxState) => state.geolocation.area);
  const isInitialSsrPage = useSelector((state: RootReduxState) => state.app.isInitialSsrPage);
  const hasExpandMySearchData = useSelector((state: RootReduxState) => state.homehub.expandMySearch.length > 0);
  // Hydrate as resolved when SSR already populated expand-search data so the
  // server and client render the section directly — no skeleton-then-swap that
  // collapses to null when ExpandMySearch / FairHousing have nothing to show.
  const [hasResolved, setHasResolved] = useState(() => isInitialSsrPage && hasExpandMySearchData);

  useEffect(() => {
    if (isInitialSsrPage && hasExpandMySearchData) {
      setHasResolved(true);
      return;
    }

    // @ts-expect-error lastViewed and expandSearch are thunk actions that don't match AnyAction type
    Promise.all([dispatch(lastViewed()), dispatch(expandSearch({ recentArea, userLocation }))])
      .then(() => setHasResolved(true))
      .catch((err) => {
        setHasResolved(true);
        dispatch(
          ErrorActions.errorHandler({
            error: err,
            errorLocation: 'HomeHub/Aside#lastViewedExpandSearch',
            errorClass: 'dataError.HomeHub/Aside#lastViewedExpandSearch',
          }),
        );
      });
  }, [dispatch, recentArea, userLocation, isInitialSsrPage, hasExpandMySearchData]);

  if (!hasResolved || !hasExpandMySearchData) {
    return null;
  }

  return (
    <section className={homeHubAsideCSS}>
      <ExpandMySearch />
      <FairHousing />
    </section>
  );
}

export default Aside;
